<template>
    <el-dialog title="关联小程序跳转APPID" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" 
    :close-on-press-escape="false">
      <!--form表单-->
      <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
        <el-form-item label="小程序APPID(可多个，英文分号隔开)" prop="wxappid">
          <el-input type="textarea"  maxlength="1000" v-model="form.wxappid"  placeholder="例: wasx1482;wfs47561">
            {{form.wxappid}}
        </el-input></el-form-item>
    
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import PortApi from '@/api/port.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '180px',
        /*是否显示*/
        loading: false,
        /*是否显示*/
        dialogVisible: false,
        /*form表单对象*/
        form: {
          wxappid:""
        },
        /*form验证*/
        formRules: {
          wxappid: [
            {
              required: true,
              message: ' ',
              trigger: 'blur'
            }
          ],
        }
      };
    },
    props: ['relwxapp'],
    watch: {
        relwxapp: function(n, o) {
        if (n != o) {
          this.dialogVisible = this.relwxapp;
          this.port_id = this.$route.query.port_id;
          this.get(this.port_id)
        }
      }
    },
    created() {
     
    },
    methods: {
      /*添加*/
      onSubmit() {
        var form = this.form;
      console.log(form)

      let self = this;
      let Params = {};
      Params.port_id = self.port_id;
      Params.wxappid = form.wxappid
      PortApi.setWxappid(Params, true)
        .then(res => {
          self.loading = false;
          console.log(res)
          if(res.msg == "success"){
              self.$message({
              message: res.data,
              type: 'success'
            });
            self.dialogFormVisible(true)
          }else{
            self.$message({
              message: res.data,
              type: 'success'
            });
          }
        
        })
        .catch(error => {self.loading = false;});
      },
  
      get(port_id) {

      let self = this;
      let Params = {};
      Params.port_id = port_id;
      console.log(Params)
      PortApi.getWxappid(Params, true)
        .then(res => {
          self.loading = false;
          self.form.wxappid = res.data
          console.log(self.form)
        })
        .catch(error => {self.loading = false;});
    },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/port/manager/codemanager/dialog/relwxapp.vue